var _style, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ebebeb } \n\t\t.s1 { fill: #f5f5f5 } \n\t\t.s2 { fill: #9aafa1 } \n\t\t.s3 { fill: #a4b7ab } \n\t\t.s4 { fill: #a0b7a8 } \n\t\t.s5 { fill: #ffffff } \n\t\t.s6 { fill: #7b9e87 } \n\t\t.s7 { fill: #799a84 } \n\t\t.s8 { fill: #9dc1a9 } \n\t\t.s9 { fill: #546f5d } \n\t\t.s10 { fill: #608f70 } \n\t\t.s11 { fill: #f0f0f0 } \n\t\t.s12 { fill: #4c785b } \n\t\t.s13 { fill: #799f86 } \n\t\t.s14 { opacity: .5;fill: #8bab96 } \n\t\t.s15 { fill: #61876e } \n\t\t.s16 { opacity: .1;fill: #000000 } \n\t\t.s17 { opacity: .8;fill: none;stroke: #ffffff;stroke-width: .5 } \n\t\t.s18 { opacity: .4;fill: #ffffff } \n\t\t.s19 { opacity: .1;fill: #ffffff } \n\t\t.s20 { opacity: .2;fill: #000000 } \n\t\t.s21 { opacity: .2;fill: #ffffff } \n\t\t.s22 { opacity: .3;fill: #000000 } \n\t\t.s23 { opacity: .5;fill: #ffffff } \n\t\t.s24 { fill: #263238 } \n\t\t.s25 { opacity: .7;fill: #ffffff } \n\t\t.s26 { fill: #e0e0e0 } \n\t\t.s27 { fill: #e3ba96 } \n\t\t.s28 { fill: #d2ac8b } \n\t\t.s29 { opacity: .4;fill: #263238 } \n\t\t.s30 { fill: #a02724 } \n\t\t.s31 { fill: #000000 } \n\t\t.s32 { fill: #a6bb8d } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    style: {
      opacity: 0.5
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--detailed-background--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 629.1h800v0.4h-800z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m592.8 645.9h84.9v0.4h-84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m436.1 653.1h93.9v0.4h-93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m545.5 653.1h30.7v0.4h-30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m160.8 645.9h69.1v0.4h-69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m127.1 642.7h24.7v0.4h-24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m210.4 652.7h86.7v0.4h-86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m381.4 525.9h-308.9c-1.2 0-2.4-0.2-3.5-0.7-1.1-0.5-2.1-1.1-3-2-0.8-0.8-1.5-1.8-1.9-2.9-0.5-1.1-0.7-2.3-0.7-3.5v-434.3c0-1.2 0.2-2.4 0.7-3.5 0.4-1.1 1.1-2.1 2-2.9 0.8-0.9 1.8-1.5 2.9-2 1.1-0.4 2.3-0.7 3.5-0.7h308.9c1.2 0 2.4 0.3 3.5 0.7 1.1 0.5 2.1 1.2 3 2 0.8 0.8 1.5 1.9 2 3 0.4 1.1 0.7 2.3 0.7 3.5v434.2c0 1.2-0.3 2.3-0.7 3.5-0.5 1.1-1.2 2.1-2 2.9-0.9 0.9-1.9 1.5-3 2-1.1 0.5-2.3 0.7-3.5 0.7zm-308.9-452.2c-1.2 0-2.3 0.3-3.3 0.7-1.1 0.4-2.1 1.1-2.9 1.9-0.8 0.8-1.4 1.8-1.9 2.8-0.4 1.1-0.6 2.2-0.6 3.4v434.3c0 1.1 0.2 2.2 0.6 3.3 0.5 1.1 1.1 2 1.9 2.8 0.8 0.8 1.8 1.5 2.9 1.9 1 0.5 2.1 0.7 3.3 0.7h308.9c1.2 0 2.3-0.2 3.4-0.7 1-0.4 2-1.1 2.8-1.9 0.8-0.8 1.5-1.7 1.9-2.8 0.4-1.1 0.7-2.2 0.7-3.3v-434.3c0-1.2-0.3-2.3-0.7-3.4-0.4-1-1.1-2-1.9-2.8-0.8-0.8-1.8-1.5-2.8-1.9-1.1-0.4-2.2-0.7-3.4-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m727.5 525.9h-308.9c-1.2 0-2.4-0.2-3.5-0.7-1.1-0.5-2.1-1.1-3-2-0.8-0.8-1.5-1.8-2-2.9-0.4-1.2-0.7-2.3-0.7-3.5v-434.3c0.1-1.2 0.3-2.4 0.8-3.5 0.4-1.1 1.1-2.1 1.9-2.9 0.9-0.9 1.9-1.5 3-2 1.1-0.4 2.3-0.7 3.5-0.7h308.9c1.2 0 2.4 0.3 3.5 0.7 1.1 0.5 2.1 1.1 2.9 2 0.9 0.8 1.6 1.8 2 2.9 0.5 1.1 0.7 2.3 0.7 3.5v434.3c0 1.2-0.2 2.3-0.7 3.5-0.4 1.1-1.1 2.1-1.9 2.9-0.9 0.9-1.9 1.5-3 2-1.1 0.5-2.3 0.7-3.5 0.7zm-308.9-452.2c-1.2 0-2.3 0.3-3.4 0.7-1 0.4-2 1.1-2.8 1.9-0.8 0.8-1.5 1.8-1.9 2.8-0.4 1.1-0.7 2.2-0.7 3.4v434.3c0 1.1 0.3 2.2 0.7 3.3 0.4 1.1 1.1 2 1.9 2.8 0.8 0.8 1.8 1.5 2.8 1.9 1.1 0.5 2.2 0.7 3.4 0.7h308.9c1.2 0 2.3-0.2 3.4-0.7 1-0.4 2-1.1 2.8-1.9 0.8-0.8 1.5-1.7 1.9-2.8 0.4-1.1 0.7-2.2 0.7-3.3v-434.3c0-1.2-0.3-2.3-0.7-3.4-0.4-1-1.1-2-1.9-2.8-0.8-0.8-1.8-1.5-2.8-1.9-1.1-0.4-2.2-0.7-3.4-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m125.5 325.3h-11.5l-3.2-4.1h17.9l-3.2 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m143.1 274.3q0 2.5-0.5 4.9-0.5 2.4-1.5 4.7-1.1 2.2-2.5 4.2-1.5 2-3.3 3.6-1.3 1.1-2.2 2.4-1 1.3-1.7 2.8-0.7 1.4-1.1 3-0.3 1.6-0.3 3.2v1.8h-20.4v-1.8q-0.1-1.6-0.4-3.2-0.4-1.6-1.1-3-0.6-1.5-1.6-2.8-1-1.3-2.2-2.4c-3.7-3.2-6.2-7.4-7.3-12.2-1.1-4.7-0.7-9.6 1.2-14.1 1.8-4.5 5-8.3 9.1-10.9 4.1-2.6 8.9-3.8 13.7-3.6 3 0.2 5.8 1 8.5 2.2 2.7 1.3 5.1 3 7.2 5.2 2 2.1 3.6 4.6 4.7 7.4 1.1 2.7 1.7 5.7 1.7 8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m110.2 280.9l1.3-0.2 5 24-1.4 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m123.1 304.7l4.9-24 1.4 0.2-4.9 24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m122.6 291.2l-2.8-5.1-2.9 5.1-5.3-6.1 1.1-0.9 4 4.6 3.1-5.6 3.1 5.6 3.9-4.6 1.1 0.9-5.3 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m130 304.8v16.3l-20.4 0.1v-16.3l20.4-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m109.6 320.5l20.4-0.1v1.4l-20.4 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m109.6 304.2l20.4-0.1v1.4l-20.4 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m671.7 160.5c-17.3 0-31.2-14-31.2-31.3 0-17.3 13.9-31.3 31.2-31.3 17.3 0 31.3 14 31.3 31.3 0 17.3-14 31.3-31.3 31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m671.8 161.2c-8.5 0-16.6-3.4-22.6-9.4-6-6-9.4-14.1-9.4-22.6 0-8.5 3.4-16.7 9.4-22.7 6-6 14.1-9.3 22.6-9.3v1.4c-8.1 0-15.9 3.2-21.6 8.9-5.7 5.8-9 13.5-9 21.6 0 8.2 3.3 15.9 9 21.7 5.7 5.7 13.5 8.9 21.6 8.9zm0 0v-1.4c8.1 0 15.9-3.2 21.6-8.9 5.8-5.8 9-13.6 9-21.7 0-8.1-3.2-15.8-9-21.6-5.7-5.7-13.5-8.9-21.6-8.9v-1.4c8.5 0 16.7 3.3 22.7 9.3 6 6 9.3 14.2 9.3 22.7 0 8.4-3.3 16.6-9.3 22.6-6 6-14.2 9.4-22.7 9.4zm16.4-32h-1.4c0-10.4-5.3-24.3-15.4-30.7l0.8-1.2c10.5 6.7 16 21.1 16 31.9zm-16 30.9l-0.8-1.2c10.1-6.4 15.4-20.3 15.4-30.7h1.4c0 10.8-5.5 25.2-16 31.9zm-15.3-30.9h-1.4c0-10.8 5.5-25.2 16-31.9l0.8 1.2c-10.1 6.4-15.4 20.3-15.4 30.7zm14.5 30.9c-10.4-6.7-16-21.1-16-31.9h1.4c0 10.4 5.3 24.3 15.4 30.7zm-0.4-62.2h1.4v62.6h-1.4zm-25.7 13.9h52.9v1.4h-52.9zm-4.8 17.2h62.5v1.4h-62.5zm5.5 17.2h51.5v1.4h-51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s9",
    d: "m584.3 314.4q-0.5 6.7-1.6 13.5-1 6.7-2.5 13.4-1.5 6.6-3.4 13.1l47 41.4-29.6 51.3-59.4-20.1c-6.2 6.6-12.9 12.8-20 18.5-7.1 5.6-14.6 10.7-22.5 15.3-7.8 4.5-16 8.5-24.4 11.8-8.5 3.4-17.2 6.1-26 8.1l-12.3 61.5h-59.2l-12.3-61.5c-8.9-2-17.5-4.7-26-8.1-8.4-3.3-16.6-7.3-24.5-11.8-7.8-4.6-15.3-9.7-22.5-15.3-7.1-5.7-13.8-11.9-20-18.5l-59.3 20.1-29.7-51.3 47.1-41.4c-2.6-8.7-4.6-17.5-6-26.5-1.3-9-2-18.1-2-27.1 0-9.1 0.7-18.2 2-27.2 1.4-8.9 3.4-17.8 6-26.5l-47.1-41.4 29.7-51.3 59.4 20.1c6.2-6.7 12.9-12.8 20-18.5 7.1-5.6 14.6-10.7 22.5-15.3 7.8-4.5 16-8.5 24.5-11.8 8.4-3.3 17.1-6 25.9-8.1l12.3-61.4h59.2l12.4 61.4c8.8 2.1 17.5 4.8 25.9 8.1 8.5 3.3 16.6 7.3 24.5 11.8 7.9 4.6 15.4 9.7 22.5 15.3 7.1 5.7 13.8 11.8 20 18.5l59.3-20.1 29.6 51.3-47 41.4q1.9 6.5 3.4 13.2 1.5 6.6 2.5 13.3 1.1 6.8 1.6 13.6 0.5 6.7 0.5 13.5 0 6.9-0.5 13.7zm-147.6 78.8c11.7-4.9 22.3-11.9 31.2-20.8 8.9-9 16-19.5 20.8-31.2 4.8-11.6 7.3-24.1 7.3-36.7 0-38.9-23.4-73.9-59.3-88.7-35.8-14.9-77.1-6.7-104.6 20.8-27.4 27.4-35.7 68.7-20.8 104.6 14.9 35.9 49.9 59.3 88.7 59.3 12.6 0 25.1-2.5 36.7-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m680.3 522.5c-4.9-2.7 1.1-25.4-5.5-35.4-4.8-7.2-13.7-11.6-17-19.8q-1-2.6-1.2-5.3-0.2-2.7 0.3-5.4 0.6-2.7 1.9-5.2 1.3-2.4 3.2-4.4 0.1-0.2 0.3-0.4 0.2-0.2 0.4-0.3 0.2-0.2 0.4-0.3 0.2-0.1 0.5-0.2 0.2-0.1 0.5-0.1 0.3-0.1 0.6-0.1 0.3 0 0.5 0 0.3 0 0.6 0.1c4.3 0.4 8.8 1.1 12.4 3.6 4.4 3 6.9 8.3 7.7 13.6 0.7 5.3-0.4 62.5-5.6 59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m682.4 491.6q0-0.4 0-0.7 0-0.4 0-0.7 0-0.4 0.1-0.7 0-0.3 0-0.7c0.1 0.6 0.1 1.1 0.1 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m700 455.7q0.7 1.6 0.9 3.3 0.2 1.8-0.1 3.5-0.3 1.7-1.1 3.3c-2.5 4.9-7.9 7.5-11.7 11.5q-1.1 1.2-2 2.5-1 1.4-1.6 2.8-0.7 1.5-1.2 3.1-0.5 1.5-0.7 3.1l-0.7-17.3q-0.1-1.3-0.1-2.5 0-1.3 0-2.6 0.1-1.2 0.2-2.5 0.2-1.3 0.4-2.5 0.3-1.2 0.8-2.4 0.5-1.2 1.2-2.2 0.7-1.1 1.6-2 0.9-0.8 2-1.5 0.9-0.5 1.9-0.8 1-0.3 2-0.5 1-0.2 2-0.3 1.1-0.1 2.1 0 0.2 0 0.4 0 0.1 0 0.3 0 0.2 0 0.4 0.1 0.1 0 0.3 0.1 0.1 0 0.3 0.1 0.1 0.1 0.2 0.2 0.2 0.1 0.3 0.3 0.1 0.1 0.2 0.2 1.1 1.4 1.7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m689.3 589.6c-13 3.6-4.3-21.9-12.4-30.9-8.1-9-17.9-17-24.3-26.9q-1.7-2.6-3-5.4-1.3-2.8-2.3-5.8-0.9-2.9-1.5-6-0.5-3.1-0.6-6.2c-0.2-6.6 1.3-13.7 6.5-18.9q0.4-0.5 1-0.9 0.5-0.4 1-0.8 0.6-0.4 1.2-0.7 0.6-0.3 1.3-0.5c4.7-1.6 10.3 0.8 13.5 4 15.8 15.8 19.1 48.5 20.4 66.1q0 0.5 0 0.9c0 3.8 0.3 31.7-0.8 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m682 570.2q0.6-24.3 1.1-48.5c0.3-15 1.3-31.4 13.4-42.8 3.1-3 7.9-5.6 12.3-4.4q0.6 0.2 1.1 0.4 0.6 0.3 1.1 0.6 0.6 0.3 1.1 0.7 0.5 0.4 0.9 0.8c5 4.5 6.7 10.9 6.8 17q0.1 2.9-0.3 5.7-0.3 2.8-1 5.6-0.8 2.8-1.9 5.4-1 2.6-2.5 5.1c-5.3 9.3-14 17.1-21 25.7-7 8.7 2.2 31.6-9.9 28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m702.1 631.4q-4.2 1.3-8.6 2-4.3 0.7-8.7 0.7-4.4 0-8.8-0.7-4.3-0.7-8.5-2l-13.6-61.8h61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m656.5 580.3h56.3v1.2h-56.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-112--inject-2",
    className: "s14",
    d: "m400 739.8c-171.6 0-310.2-8.1-310.2-18.1 0-10 138.6-18.1 310.2-18.1 171.6 0 310.2 8.1 310.2 18.1 0 10-138.6 18.1-310.2 18.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--smartphone-screen--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--smartphone-screen--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m610 490.9h-92c-2 0-4-0.4-5.9-1.2-1.8-0.8-3.5-2-4.9-3.5-1.3-1.5-2.3-3.2-3-5.2-0.6-1.9-0.8-3.9-0.6-5.9l17.5-200.2c0.2-2.1 0.8-4.1 1.8-6 1-2 2.2-3.7 3.8-5.1 1.6-1.5 3.4-2.6 5.4-3.4 2-0.8 4.1-1.2 6.2-1.3h92c2 0 4 0.4 5.9 1.2 1.8 0.8 3.5 2 4.8 3.5 1.4 1.5 2.4 3.3 3.1 5.2 0.6 1.9 0.8 3.9 0.6 5.9l-17.5 200.2c-0.2 2.1-0.8 4.2-1.8 6.1-0.9 1.9-2.2 3.6-3.8 5-1.6 1.5-3.4 2.6-5.4 3.4-2 0.8-4.1 1.2-6.2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m610 490.9h-92c-2 0-4-0.4-5.9-1.2-1.8-0.8-3.5-2-4.9-3.5-1.3-1.5-2.3-3.2-3-5.2-0.6-1.9-0.8-3.9-0.6-5.9l17.5-200.2c0.2-2.1 0.8-4.1 1.8-6 1-2 2.2-3.7 3.8-5.1 1.6-1.5 3.4-2.6 5.4-3.4 2-0.8 4.1-1.2 6.2-1.3h92c2 0 4 0.4 5.9 1.2 1.8 0.8 3.5 2 4.8 3.5 1.4 1.5 2.4 3.3 3.1 5.2 0.6 1.9 0.8 3.9 0.6 5.9l-17.5 200.2c-0.2 2.1-0.8 4.2-1.8 6.1-0.9 1.9-2.2 3.6-3.8 5-1.6 1.5-3.4 2.6-5.4 3.4-2 0.8-4.1 1.2-6.2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m572.5 476.1q-0.1 1.5-0.8 2.9-0.7 1.4-1.8 2.4-1.1 1.1-2.6 1.6-1.4 0.6-2.9 0.6c-1 0-1.9-0.1-2.8-0.5-0.9-0.4-1.7-1-2.3-1.7-0.7-0.7-1.2-1.5-1.5-2.4-0.3-1-0.4-1.9-0.3-2.9q0.2-1.5 0.9-2.9 0.7-1.3 1.8-2.4 1.1-1 2.5-1.6 1.5-0.6 3-0.6c1 0 1.9 0.2 2.8 0.6 0.9 0.3 1.7 0.9 2.3 1.6 0.7 0.7 1.2 1.6 1.5 2.5 0.3 0.9 0.4 1.9 0.2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m597.7 277.1h-29.8q-0.6 0-1.1-0.3-0.5-0.2-0.8-0.6-0.4-0.4-0.6-0.9-0.1-0.5-0.1-1v-0.7q0.1-0.6 0.3-1.1 0.3-0.5 0.7-0.9 0.4-0.4 1-0.6 0.5-0.2 1.1-0.2h29.7q0.6 0 1.1 0.2 0.5 0.2 0.9 0.6 0.3 0.4 0.5 0.9 0.2 0.5 0.1 1.1v0.7q-0.1 0.5-0.3 1-0.3 0.5-0.7 0.9-0.4 0.4-0.9 0.6-0.6 0.2-1.1 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m619.2 457.5h-105.9l14.9-170.7h106l-15 170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m591.7 259.9h30.3l-50.7 231h-30.9l51.3-231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m567.7 259.9h15.1l-50.8 231h-15.6l51.3-231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m547 448.3h-26.2l1.6-18.1h26.1l-1.5 18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m580.2 448.3h-26.2l1.6-18.1h26.2l-1.6 18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m613.4 448.3h-26.2l1.6-18.1h26.2l-1.6 18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m617.5 402.1l-0.2 1.6h-92.6l0.1-1.6h92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m617.5 402.1l-0.2 1.6h-92.6l0.1-1.6h92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m618 396h-8.5l0.7-8.5h8.6l-0.8 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m576 396h-8.6l0.8-8.5h8.5l-0.7 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m534 396h-8.6l0.8-8.5h8.5l-0.7 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m616 418.9h-24.3l0.5-5.9h24.3l-0.5 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m587.2 378.2h-60.2l0.6-6h60.1l-0.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m587.2 378.2h-60.2l0.6-6h60.1l-0.5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m561.7 299.2h-27.8l0.6-6.4h27.7l-0.5 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m561.7 299.2h-27.8l0.6-6.4h27.7l-0.5 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m530.5 423c-1 0-1.9-0.1-2.8-0.5-0.8-0.4-1.6-0.9-2.3-1.6-0.6-0.7-1.1-1.6-1.4-2.5-0.3-0.9-0.4-1.8-0.3-2.7q0.2-1.5 0.9-2.9 0.6-1.3 1.7-2.3 1.2-1.1 2.5-1.6 1.4-0.6 2.9-0.6c1 0 1.9 0.2 2.8 0.5 0.9 0.4 1.6 1 2.3 1.7 0.6 0.7 1.1 1.5 1.4 2.4 0.3 0.9 0.4 1.8 0.3 2.8q-0.2 1.5-0.9 2.8-0.6 1.3-1.7 2.4-1.1 1-2.5 1.5-1.4 0.6-2.9 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m620.4 367.4h-92.5l5.6-63.9h92.5l-5.6 63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m521.1 275.5c0.2-2.2 0.8-4.3 1.8-6.3 1-2 2.3-3.7 3.9-5.2 1.7-1.5 3.5-2.7 5.6-3.5 2-0.8 4.2-1.2 6.4-1.3h31.8l-0.6 6.7c-0.2 1.9-0.7 3.8-1.6 5.5-0.9 1.8-2 3.3-3.5 4.6-1.4 1.4-3.1 2.4-4.9 3.1-1.8 0.7-3.7 1.1-5.7 1.2h-33.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m645.5 317.6l0.5-7.7 1.6 0.1-0.5 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m646.5 303l1.6-22.3 1.6 0.1-1.6 22.3z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor-screen--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor-screen--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m551.1 259.3h-271.4l15.1-172.1h271.4l-15.1 172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m547.4 272.7h-267.4c-1.8 0.1-3.5-0.3-5.1-1-1.6-0.7-3.1-1.7-4.3-3-1.2-1.3-2.1-2.8-2.6-4.5-0.5-1.7-0.7-3.4-0.5-5.2l14.9-171c0.2-1.8 0.7-3.6 1.6-5.3 0.8-1.6 1.9-3.1 3.3-4.4 1.3-1.2 2.9-2.2 4.7-2.9 1.7-0.7 3.5-1.1 5.4-1.1h267.4c1.8 0 3.5 0.3 5.1 1 1.6 0.7 3.1 1.7 4.3 3 1.2 1.3 2 2.9 2.6 4.6 0.5 1.6 0.7 3.4 0.5 5.1l-14.9 171c-0.2 1.9-0.7 3.7-1.6 5.3-0.8 1.7-1.9 3.2-3.3 4.4-1.4 1.3-3 2.3-4.7 3-1.7 0.7-3.6 1-5.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m551.1 259.3h-271.4l15.1-172.1h271.4l-15.1 172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m551.1 259.3h-271.4l15.1-172.1h271.4l-15.1 172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m533.5 137.2h-49.8l2.4-28.1h49.9l-2.5 28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m528.7 192.5h-49.9l2.5-28.1h49.8l-2.4 28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m523.8 247.7h-49.8l2.4-28h49.9l-2.5 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m309.8 226.3h143.9l-0.2 1.6h-143.8l0.1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m453.7 226.3l-0.2 1.6h-143.8l0.1-1.6h143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m328.5 74.4h17.2l-52.4 198.3h-17.8l53-198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m356 74.4h34.8l-52.4 198.3h-35.4l53-198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m455.3 208h-143.7l8.7-99.2h143.6l-8.6 99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m315.6 247.1c-1 0-1.9-0.2-2.8-0.5-0.8-0.4-1.6-1-2.3-1.7-0.6-0.7-1.1-1.5-1.4-2.4-0.3-0.9-0.4-1.8-0.3-2.8q0.2-1.5 0.9-2.8 0.6-1.3 1.8-2.4 1.1-1 2.5-1.5 1.3-0.6 2.8-0.6c1 0 1.9 0.1 2.8 0.5 0.9 0.4 1.6 0.9 2.3 1.6 0.6 0.7 1.1 1.6 1.4 2.5 0.3 0.9 0.4 1.8 0.3 2.7q-0.2 1.5-0.9 2.9-0.6 1.3-1.7 2.3-1.1 1.1-2.5 1.6-1.4 0.6-2.9 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m382.4 220.2h-71.8l0.5-6.4h71.8l-0.5 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m382.4 220.2h-71.8l0.5-6.4h71.8l-0.5 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m452.1 242.9h-27.7l0.5-6.3h27.8l-0.6 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m454.2 220.2h-6.3l0.5-6.4h6.4l-0.6 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m443.4 220.2h-6.3l0.6-6.4h6.3l-0.6 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m432.7 220.2h-6.3l0.5-6.4h6.3l-0.5 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m464.5 102.7h-107.7l0.4-5.5h107.8l-0.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m348.2 103.1h-27.7l0.5-6.3h27.8l-0.6 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m348.2 103.1h-27.7l0.5-6.3h27.8l-0.6 6.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m535.8 70.6v-1.6l7.7 0.1v1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m507.4 70.5v-1.6l22.4 0.2v1.6z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--drawing-table--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--drawing-table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m449.7 306h8.7l-16 176.3h-8.2l15.5-176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m449.7 306h8.7l-16 176.3h-8.2l15.5-176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m447.3 390.9l1.5-0.2 11.3 85.3-1.6 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m438.3 472.8h-266.7l14.6-166.8h266.7l-14.6 166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m438.3 472.8h-266.7l14.6-166.8h266.7l-14.6 166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m230 492.8h11.1l18 234.2h-8l-21.1-234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m495.3 491.2h11l18.1 235.8h-8l-21.1-235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m173.8 491.2h329.3v37.1h-329.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m445.2 491.5l57.9-0.3v37.1h-59.2l1.3-36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m173.9 491.4h266.3v37.2h-266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m181.1 491.2l-3.4 235.8h-8l0.3-235.8h11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m446.4 491.2l-3.4 235.8h-8l0.3-235.8h11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m170 491.2h11.1l-3.4 235.8h-8l0.3-235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m446.4 491.2l-3.4 235.8h-8l0.3-235.8h11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m160.9 482.3c0-5.1 1.8-9.1 4.1-9.1h346.4c2.3 0 4.1 4 4.1 9.1 0 4.9-1.8 9-4.1 9h-346.4c-2.3 0-4.1-4.1-4.1-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m160.9 482.3c0-5.1 1.8-9.1 4.1-9.1h346.4c2.3 0 4.1 4 4.1 9.1 0 4.9-1.8 9-4.1 9h-346.4c-2.3 0-4.1-4.1-4.1-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m426.1 482.3c0-5.1 1.9-9.1 4.2-9.1h81.1c2.3 0 4.1 4 4.1 9.1 0 4.9-1.8 9-4.1 9h-81.1c-2.3 0-4.2-4.1-4.2-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m421.3 451.3h-80.7l11.4-130.2h80.7l-11.4 130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m422 452.1h-82.3l11.5-131.8h82.4zm-80.6-1.6h79.1l11.2-128.5h-79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m367 445.5h-19.7l1.2-13.9h19.7zm-18.8-0.8h18.1l1-12.2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m390.9 445.5h-19.7l1.2-13.9h19.7zm-18.8-0.8h18l1.1-12.2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m414.8 445.5h-19.6l1.2-13.9h19.6zm-18.8-0.8h18.1l1-12.2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m350.6 412h66.8v0.8h-66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m396.1 393.4h-44.1l0.4-5.1h44.2zm-43.2-0.8h42.5l0.3-3.5h-42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m416.6 425.9h-18.3l0.4-5.1h18.3zm-17.4-0.8h16.7l0.3-3.4h-16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m418.3 406.2h-7l0.6-7h7zm-6.1-0.8h5.4l0.5-5.3h-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m388 406.2h-6.9l0.6-7h6.9zm-6.1-0.8h5.4l0.5-5.3h-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m357.8 406.2h-7l0.6-7h7zm-6.1-0.8h5.4l0.4-5.3h-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m378 333.3h-20.8l0.5-5.4h20.8zm-19.9-0.8h19.2l0.3-3.8h-19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m355.6 427.3h-1.7q-1 0-1.8-0.4-0.9-0.4-1.5-1.1-0.7-0.6-1-1.5-0.3-0.9-0.2-1.8l0.2-1.8q0.1-1 0.5-1.8 0.5-0.9 1.2-1.6 0.7-0.6 1.6-1 0.9-0.4 1.9-0.4h1.7q1 0 1.8 0.4 0.9 0.3 1.5 1 0.7 0.7 1 1.6 0.3 0.9 0.2 1.8l-0.2 1.8q-0.1 0.9-0.5 1.8-0.5 0.9-1.2 1.5-0.7 0.7-1.6 1.1-0.9 0.3-1.9 0.4zm-0.8-10.6q-0.8 0-1.6 0.3-0.8 0.3-1.4 0.9-0.6 0.5-1 1.3-0.3 0.7-0.4 1.5l-0.2 1.8q-0.1 0.7 0.2 1.5 0.2 0.7 0.7 1.3 0.6 0.6 1.3 0.9 0.7 0.3 1.5 0.3h1.7q0.8-0.1 1.6-0.4 0.8-0.3 1.4-0.8 0.6-0.6 1-1.3 0.3-0.8 0.4-1.6l0.2-1.7q0-0.4 0-0.8-0.1-0.4-0.2-0.8-0.1-0.3-0.3-0.7-0.2-0.3-0.5-0.6-0.2-0.3-0.5-0.5-0.3-0.2-0.7-0.4-0.3-0.1-0.7-0.2-0.4-0.1-0.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m420.1 384h-67.3v-0.4l4-46.4h67.4v0.4zm-66.5-0.8h65.8l3.9-45.2h-65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m357 337.9l0.4-0.6 62.6 46-0.5 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m353 383.3l37.7-24.6 0.4 0.7-37.7 24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m366.4 445.4l-17.7-13.1 0.4-0.6 17.8 13-0.5 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m347.6 444.7l20-13 0.4 0.7-20 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m390.3 445.4l-17.7-13.1 0.5-0.6 17.7 13-0.5 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m371.5 444.7l20-13 0.4 0.6-20 13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m414.2 445.4l-17.7-13.1 0.5-0.6 17.7 13-0.5 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m395.4 444.7l20-13 0.5 0.7-20 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m330.5 423.1h-149.2l8.9-101.6h149.2l-8.9 101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m331.2 423.9h-150.8l9-103.2h150.8zm-149-1.6h147.6l8.7-100.1h-147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m198.6 405.1h81v0.8h-81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m281.3 390.3h-81.6v-0.4l5-56.3h81.7v0.5zm-80.9-0.8h80.1l4.8-55.1h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m203 417.1h-2.2q-0.3 0-0.7 0-0.3-0.1-0.6-0.2-0.3-0.2-0.6-0.4-0.3-0.2-0.5-0.4-0.2-0.2-0.4-0.5-0.1-0.3-0.2-0.6-0.1-0.4-0.2-0.7 0-0.3 0-0.7l0.2-2.2q0.1-0.7 0.4-1.3 0.3-0.6 0.8-1.1 0.5-0.4 1.2-0.7 0.6-0.3 1.3-0.3h2.2q0.3 0 0.7 0.1 0.3 0.1 0.6 0.2 0.3 0.1 0.6 0.3 0.3 0.2 0.5 0.5 0.2 0.2 0.4 0.5 0.1 0.3 0.2 0.6 0.2 0.3 0.2 0.6 0 0.4 0 0.7l-0.2 2.2q-0.1 0.7-0.4 1.3-0.3 0.6-0.8 1.1-0.5 0.5-1.2 0.7-0.6 0.3-1.3 0.3zm-1.5-8.3q-0.5 0-1 0.2-0.5 0.2-0.9 0.6-0.4 0.4-0.7 0.9-0.2 0.5-0.3 1l-0.2 2.2q0 0.5 0.1 1 0.2 0.5 0.5 0.9 0.3 0.3 0.8 0.5 0.5 0.2 1 0.2h2.2q0.5 0 1-0.2 0.5-0.2 1-0.6 0.4-0.3 0.6-0.8 0.2-0.5 0.3-1.1l0.2-2.2q0.1-0.5-0.1-1-0.2-0.4-0.5-0.8-0.3-0.4-0.8-0.6-0.5-0.2-1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m240 400.4h-41.2l0.4-4.4h41.2zm-40.4-0.8h39.7l0.2-2.8h-39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m279.2 414.8h-16.5l0.4-4.4h16.4zm-15.5-0.8h14.8l0.2-2.8h-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m280.5 400.4h-4.4l0.4-4.4h4.3zm-3.5-0.8h2.8l0.3-2.8h-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m274.4 400.4h-4.4l0.4-4.4h4.4zm-3.5-0.8h2.8l0.2-2.8h-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m268.4 400.4h-4.4l0.4-4.4h4.4zm-3.5-0.8h2.8l0.2-2.8h-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m286.7 329.4h-61.5l0.3-3.9h61.5zm-60.6-0.8h59.9l0.2-2.3h-59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m221.2 329.6h-16.4l0.4-4.3h16.4zm-15.6-0.8h14.9l0.2-2.8h-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m325.3 352h-28.8l1.4-16.6h28.8zm-28-0.8h27.2l1.4-15h-27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m322.5 383.1h-28.8l1.5-16.5h28.8zm-28-0.8h27.2l1.3-15h-27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m319.8 414.3h-28.8l1.5-16.6h28.8zm-28-0.8h27.2l1.3-15h-27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m296.7 351.2l29.4-15.8 0.4 0.7-29.4 15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m324.7 351.9l-26.7-15.7 0.4-0.7 26.7 15.8-0.4 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m292.7 382.3l29.4-15.7 0.4 0.7-29.4 15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m295.3 367.8l0.4-0.7 26.7 15.8-0.4 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s26",
    d: "m290.9 414.7l1.5-17.2 13.7 8.1 14.5-7.8 0.4 0.7-14.1 7.6 12.8 7.5-0.4 0.7-13.1-7.8zm2.2-15.8l-1.3 14.4 13.4-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m199.9 389.5l85.8-55.8 0.4 0.7-85.8 55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m204.8 334.3l0.4-0.6 76 55.9-0.5 0.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m310.4 676.8c1.9 1.4 2.8 5 1.9 8.8-2.4 9.9-5.2 22.6-6.1 26.3-1.4 5.9-15.8 1.4-15.8 1.4l1.8-39c9.6 0.2 15 0.2 18.2 2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m220.3 683.2c0 0-15.7 19.2-20.5 25.1-3.5 4.3-12.1-6.4-12.1-6.4l15-29.6c23 11.6 17.6 10.9 17.6 10.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m195.6 686.3l4.2-8.3 19 7-6.6 8.2-16.6-6.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m291.5 688.7h20.2l-2.3 9h-18.3l0.4-9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m196.4 443.3l11.6-7.8c1.3-0.8 4.1 11.6 4.1 11.6l-8.5 6.3-7.2-8.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m216.9 357.2l-26.6 21.9q-0.1 0.1-0.2 0.2-0.1 0.2-0.1 0.3 0 0.2 0 0.4 0 0.1 0.1 0.3c4.5 6.8 15.5 39.1 15.5 39.1l-9.2 6.6c0 0-18.6-28.9-26.4-43.3q-1-2-1.5-4.2-0.4-2.1-0.1-4.3 0.2-2.2 1.1-4.3 1-2 2.4-3.6l31.4-28.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m205.5 419.3c4.6 0.6 3.7 15.3 3.7 15.3l-12.8 8.6v-17.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m268.9 567.4q-0.1 2.9-0.3 5.8-0.2 2.9-0.6 5.7-0.3 2.9-0.8 5.8-0.5 2.8-1.2 5.6c-9.1 38.6-45.2 93.9-45.2 93.9l-21-7.9c0 0 29.7-80 33.1-100.4 2.8-16.7-22.8-77.4-30.3-102.1-5.3-17.9 2.2-34.6 2.2-34.6 0 0 19.4 2.6 42.3 4.1l9 41.4 4.1 19.2q1.2 4 2.2 8.1 1 4.1 1.9 8.1 0.9 4.1 1.6 8.3 0.7 4.1 1.2 8.2l0.2 1.5q0.3 1.8 0.5 3.6 0.3 3.2 0.6 6.4 0.2 3.2 0.4 6.4 0.1 3.3 0.2 6.5 0 3.2-0.1 6.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m268.9 567.4q-0.1 2.9-0.3 5.8-0.2 2.9-0.6 5.7-0.3 2.9-0.8 5.8-0.5 2.8-1.2 5.6c-9.1 38.6-45.2 93.9-45.2 93.9l-21-7.9c0 0 29.7-80 33.1-100.4 2.8-16.7-22.8-77.4-30.3-102.1-5.3-17.9 2.2-34.6 2.2-34.6 0 0 19.4 2.6 42.3 4.1l9 41.4 4.1 19.2q1.2 4 2.2 8.1 1 4.1 1.9 8.1 0.9 4.1 1.6 8.3 0.7 4.1 1.2 8.2l0.2 1.5q0.3 1.8 0.5 3.6 0.3 3.2 0.6 6.4 0.2 3.2 0.4 6.4 0.1 3.3 0.2 6.5 0 3.2-0.1 6.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m268.9 567.4c-3-10.3-15.2-40.6-31.2-70.8-16.1-30.4 1.6-37.7 1.6-37.7 6.8 2.5 12.3 12.6 16.8 25.8 5.2 15.6 8.9 35.5 11 51.9l0.2 1.5q0.3 1.8 0.5 3.6 0.3 3.2 0.6 6.4 0.2 3.2 0.4 6.4 0.1 3.3 0.2 6.5 0 3.2-0.1 6.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m326.4 582.5c3.5 32.2-15.2 111.6-15.2 111.6h-21.3c0 0-0.2-101.4-1.6-109.6-1.8-10.3-16.4-33-32.4-69.9-7.2-16.7-30.7-15.1-30.7-48.3 0-9.1 3.7-21.7 3.7-21.7l54.7 4.1c0 0 39.3 101.6 42.8 133.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.4
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m326.4 582.5c3.5 32.2-15.2 111.6-15.2 111.6h-21.3c0 0-0.2-101.4-1.6-109.6-1.8-10.3-16.4-33-32.4-69.9-7.2-16.7-30.7-15.1-30.7-48.3 0-9.1 3.7-21.7 3.7-21.7l54.7 4.1c0 0 39.3 101.6 42.8 133.8z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m357.2 340.4l31.8 16q0.1 0 0.1 0.1 0.1 0 0.1 0.1 0.1 0 0.1 0.1 0.1 0 0.1 0l2.1 2.4-3-0.1q0 0-0.1 0-0.1 0-0.1 0-0.1 0-0.2-0.1-0.1 0-0.1 0l-32.3-15.1q-0.2-0.1-0.4-0.3-0.2-0.2-0.3-0.5-0.1-0.2-0.1-0.5 0-0.3 0.1-0.5l0.3-0.8q0.1-0.3 0.3-0.5 0.2-0.2 0.5-0.3 0.3-0.1 0.6-0.1 0.3 0 0.5 0.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-2",
    className: "s27",
    d: "m363 353.9l10.2-5.5-1.7 14.7c0 0-8.4 5-13.5-0.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-2",
    className: "s27",
    d: "m384.7 354.3l-0.8 4.7q-0.1 0.6-0.4 1.1-0.3 0.5-0.7 0.9-0.4 0.3-0.9 0.6-0.5 0.2-1 0.3l-9.4 1.2 1.7-14.7 8.8 2q0.6 0.1 1.2 0.5 0.5 0.4 0.9 0.9 0.4 0.6 0.5 1.2 0.2 0.7 0.1 1.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m289.5 349.4q2.1-2 4.2-3.9 2.1-2 4.3-3.8 2.2-1.9 4.4-3.7l17.4 44 43.2-28.1 1.4 11.4c0 0-34.5 43-51.7 36.8-19-7-27.3-48.7-27.3-48.7q2-2 4.1-4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s15",
    d: "m205.8 711.3q-0.5-0.4-1-0.8-0.4-0.4-0.9-0.8-0.4-0.4-0.8-0.8-0.5-0.4-0.9-0.8 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.2 0 0 0-0.1 0.1 0 0.1 0 0-0.1 0.1-0.1 0 0 0.1 0 0.1-0.1 0.1 0c0.8 0.1 7.6 1.2 8.5 3.1q0 0.1 0 0.2 0.1 0.2 0.1 0.3-0.1 0.2-0.1 0.3-0.1 0.2-0.1 0.3-0.2 0.2-0.3 0.4-0.2 0.1-0.4 0.3-0.2 0.1-0.5 0.2-0.2 0.1-0.4 0.1-0.5 0-1-0.1-0.5-0.1-1-0.3-0.4-0.2-0.8-0.5-0.5-0.2-0.8-0.5zm-2.3-3c2.4 2.4 4.5 3.8 5.7 3.7q0.2 0 0.3-0.1 0.2 0 0.3-0.1 0.2-0.1 0.3-0.2 0.1-0.1 0.2-0.3 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0-0.1 0-0.1c-0.4-1.1-4-2.1-6.8-2.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s15",
    d: "m202.3 708.1q0 0-0.1-0.1 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1c0.2-0.2 4.4-4.8 7.2-2.8l0.2 0.2c0.8 0.6 0.7 1.2 0.5 1.6-0.8 1.6-5.7 2-7.6 1.6zm6.6-2.8c-1.8-1.3-4.5 1.1-5.7 2.2 2.2 0.2 5.7-0.4 6.2-1.4 0 0 0.2-0.2-0.3-0.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m186.9 699.8q0.3-0.3 0.8-0.5 0.4-0.1 0.8-0.1 0.5 0.1 0.9 0.3l13.4 6.6c0 0 5.5 10.6 15.1 13.1q0.3 0.1 0.6 0.3 0.3 0.1 0.5 0.4 0.2 0.2 0.4 0.5 0.2 0.2 0.2 0.5l0.3 1q0.3 0.8 0.2 1.6-0.1 0.8-0.6 1.5-0.4 0.7-1.1 1.1-0.7 0.5-1.6 0.5c-6.6 0.2-13.6 1.6-25.3-3.7-2.3-1-7.5-4.2-11.4-6.5q-0.4-0.2-0.7-0.6-0.3-0.3-0.4-0.8-0.1-0.4-0.1-0.9 0.1-0.5 0.3-0.9l7.1-12.8q0.3-0.4 0.6-0.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s15",
    d: "m310.9 715.9q-0.5-0.2-1.1-0.5-0.5-0.2-1.1-0.5-0.5-0.2-1-0.5-0.6-0.3-1.1-0.6 0 0-0.1-0.1 0 0 0-0.1-0.1 0-0.1-0.1 0 0 0-0.1 0.1 0 0.1-0.1 0 0 0-0.1 0.1 0 0.1 0 0.1 0 0.1-0.1c0.8-0.1 7.7-1 9 0.6q0.1 0.1 0.2 0.2 0.1 0.2 0.1 0.3 0 0.1 0 0.3 0 0.1 0 0.3-0.1 0.2-0.2 0.4-0.1 0.3-0.3 0.4-0.1 0.2-0.3 0.4-0.2 0.1-0.5 0.2-0.4 0.1-0.9 0.2-0.5 0-1 0-0.5-0.1-0.9-0.2-0.5-0.1-1-0.3zm-3-2.2c3 1.6 5.4 2.3 6.5 1.9q0.2-0.1 0.3-0.2 0.2-0.1 0.3-0.2 0.1-0.1 0.1-0.3 0.1-0.1 0.1-0.3 0.1 0 0.1-0.1 0 0 0-0.1 0 0-0.1-0.1 0-0.1 0-0.1c-0.8-0.9-4.5-0.8-7.3-0.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s15",
    d: "m306.3 714.1l-0.2-0.1q0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1c0.1-0.2 2.8-5.8 6.1-4.8l0.2 0.1c0.9 0.4 1 1 1 1.4-0.3 1.7-4.8 3.6-6.9 3.8zm5.6-4.6c-2.1-0.7-4 2.4-4.8 3.8 2.2-0.5 5.3-2.1 5.5-3.1 0 0 0.1-0.3-0.5-0.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m293 713.5c5.7 1.2 12.5-1.8 13-1.1q0.8 1 1.7 1.9 1 0.8 2.2 1.3 1.1 0.6 2.3 0.9 1.3 0.2 2.6 0.2c6.1 0 7 0.3 13.6 0.1q0.2 0 0.4 0 0.2 0.1 0.3 0.2 0.2 0.1 0.4 0.2 0.1 0.2 0.2 0.3 0.3 0.5 0.6 1.2 0.3 0.7 0.4 1.5 0 0.7-0.3 1.5-0.2 0.7-0.7 1.3-0.5 0.6-1.2 1c-4.8 2.6-16.7 8.7-23.8 9.9-5.5 0.9-10.3 1.2-13.3 0.1-1.9-0.8-3.2-4.3-3.2-6.4-0.1-4.4-0.2-8.5 0-11.2 0 0-1-4.1 4.8-2.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m236.1 315.9c-0.5 5.3-3.7 9.9-6.4 14.6q-2.1 3.5-3.8 7.3-1.8 3.8-3.2 7.7-1.4 3.9-2.4 7.9-1.1 4.1-1.8 8.2-2.7-2-5.3-4.2-2.5-2.2-4.9-4.6-2.3-2.5-4.4-5.1-2.1-2.7-3.9-5.5-0.2-0.3-0.4-0.6-0.2-0.3-0.3-0.6-0.1-0.3-0.2-0.7-0.2-0.3-0.2-0.6 0-0.6 0.1-1.2 0.1-0.6 0.3-1.1 0.2-0.6 0.6-1 0.3-0.5 0.7-0.9 1.5-1.9 3.2-3.5 1.8-1.7 3.6-3.2 1.9-1.5 3.9-2.9 2-1.3 4.1-2.4 2.1-1.3 4.3-2.5 2.2-1.2 4.5-2.4 2.2-1.1 4.5-2.1 2.2-1.1 4.5-2.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m314.2 282.8q0 1.4 0 2.7 0.1 1.3 0.2 2.6 0.1 1.3 0.3 2.6 0.2 1.3 0.5 2.6c-2.3 0.8-4.9-1.3-4.9-1.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s31",
    d: "m312.4 292q-0.1 0-0.3 0-0.1 0-0.3 0-0.1-0.1-0.3-0.1-0.1 0-0.3-0.1c-2.9-0.8-4.3-4.6-3.2-8.3 1.1-3.8 4.4-6.2 7.2-5.3q0.6 0.1 1.1 0.4 0.5 0.3 0.9 0.8 0.5 0.4 0.8 0.9 0.3 0.5 0.4 1.1 0.2 0.6 0.3 1.2 0.1 0.7 0.1 1.3 0 0.7-0.1 1.3-0.1 0.7-0.3 1.3c-0.9 3.2-3.4 5.5-6 5.5zm1.6-13.2c-2.2 0-4.4 2-5.2 4.9-1 3.3 0.2 6.6 2.6 7.4q0.1 0 0.2 0 0.2 0 0.3 0.1 0.1 0 0.2 0 0.2 0 0.3 0c2.2 0 4.4-2.1 5.2-4.9q0.2-0.6 0.3-1.1 0.1-0.6 0.1-1.2 0-0.6-0.1-1.2-0.1-0.6-0.3-1.1-0.1-0.5-0.4-0.9-0.2-0.5-0.6-0.8-0.3-0.4-0.7-0.7-0.4-0.2-0.9-0.4-0.1 0-0.2 0-0.2-0.1-0.3-0.1-0.1 0-0.2 0-0.1 0-0.3 0z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m274.1 280.7l5.3 10.9 7.3 14.8q-0.5 0.4-1 0.8-0.4 0.5-0.8 0.9-0.4 0.5-0.8 1-0.3 0.5-0.6 1c-2.1 3.1-3.7 5.4 2.6 11q0.5 0.4 0.9 1 0.3 0.6 0.5 1.2 0.2 0.6 0.3 1.3 0 0.7-0.2 1.3c-0.7 2.1-3.1 3.9-10.4 1.6q-2.6-0.8-5.1-2.1-2.4-1.3-4.6-2.9-2.3-1.6-4.2-3.6-2-1.9-3.6-4.2c-2.1-2.8-1.3-4.6 1.4-6.9 7.7-6.3 11.1-17.8 13-27.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m309.6 297.5q-1.3 2-3.1 3.7-1.7 1.7-3.8 3-2.1 1.2-4.5 2-2.3 0.7-4.7 0.9-0.9 0.1-1.7 0.1-0.8 0-1.7-0.1-0.8-0.1-1.6-0.2-0.8-0.2-1.6-0.4-2-0.5-3.8-1.4-1.8-0.9-3.3-2.2-1.6-1.3-2.8-2.9-1.3-1.6-2.1-3.5c-4.6-9.6-1.5-17.7 2.6-32 0.9-3.3 2.6-6.4 5-8.9 2.5-2.4 5.5-4.3 8.8-5.3 3.3-1 6.8-1.2 10.2-0.5 3.4 0.7 6.5 2.2 9.2 4.5 11.8 10.2 6.4 31.6-1.1 43.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m293.5 307.1q-0.9 0.1-1.7 0.1-0.8 0-1.7-0.1-0.8 0-1.6-0.2-0.8-0.1-1.6-0.3l-0.2-0.2 2.1-2.2c0 0 0.1 2.5 4.7 2.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m285.2 248q-0.3-0.7-0.7-1.4-0.3-0.7-0.8-1.3-0.5-0.6-1.1-1.1-0.6-0.5-1.2-1 0.9-0.1 1.8 0.1 0.8 0.2 1.6 0.7 0.8 0.4 1.4 1.1 0.6 0.7 0.9 1.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m331 270c-3.8 3.9-13.4 2.2-13.4 2.2l-4.1-4c-0.9-0.8-2.8-1.6-4.1 3l-1.8 3.9c0 0-4.8 7.7-11.8 11.4-1 0.6-3.7 2.5-3.7 2.5q-1.8 1.1-3.9 1.8-2 0.6-4.2 0.7-2.1 0.1-4.2-0.4-2.1-0.5-4-1.5l-1.8-0.7q-0.7-0.3-1.3-0.8-0.6-0.4-1.1-1.1-0.4-0.6-0.7-1.3-0.2-0.7-0.3-1.5c-0.4-7.9-0.9-27.3 5.6-33.6 5.9-5.8 9-3.9 11.2-4.5q1.8-1 3.7-1.6 2-0.6 4-0.8 2-0.2 4 0.1 2.1 0.2 4 0.8c15.8 5.5 15.2 14.8 18.4 14.4q0.7-0.2 1.4-0.4 0.7-0.2 1.3-0.6 0.7-0.3 1.3-0.7 0.5-0.5 1-1c-0.2 0.4-3.6 5.9-2 6.1 1.6 0.2 5.9-3.6 5.5-2.5-0.3 1.1-5 5.9-2.2 7 2.6 1.1 6.8-2.7 6.8-2.7 0 0 0.1 1.8-3.6 5.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    className: "s24",
    d: "m285.5 250.8c-3.1-4.2-3.1-11.3 4.8-12.3 2.7-4.4 12.3-3.2 16 2.2 5.9-0.6 8.7 3.4 12.3 9.3q1.5 0.2 2.9 0.8 1.4 0.6 2.6 1.6 1.2 0.9 2 2.2 0.8 1.3 1.3 2.7c0.8 3.8 4.4 4.8 5.4 4 2.6 6.6 0.8 12.1-4.7 15-5.5 2.9-8.2-0.6-11.2-3.5-3.4 0.6-7.9-4-10-9-2.9 1.3-8.6 0.2-11.7-5.5-2.7 0.9-10.7-5-9.7-7.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m300 273.2l0.4-0.6 19.2 12.5-0.4 0.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m300.2 272.9c3.5 2 4.3 7.7 3.2 11.3-1.3 4.1-5.7 6.4-8.2 2.9q-0.7-1-1.3-2.1-0.5-1.1-0.8-2.3-0.3-1.2-0.4-2.4-0.1-1.3 0-2.5c0.5-4.1 4-6.9 7.5-4.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m267.1 311.8c16.5 1.1 33.8 8.8 36.1 12.8 4.5 7.9-15.9 56.8-19 77.3-3 20.5 0 47.2 0 47.2l-80-5.6c0 0 4-27.9 9-69.5 4.9-41.6 20-59.6 20-59.6 0 0 18-3.7 33.9-2.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m308.9 336.4c0.6 6 5.6 21.2 4.8 23.1q-0.2 0.4-0.5 0.7-0.3 0.4-0.6 0.6-0.4 0.3-0.7 0.5-0.4 0.2-0.8 0.3-3.2 1.3-6.5 2.4-3.3 1-6.7 1.7-3.3 0.8-6.8 1.2-3.4 0.4-6.8 0.6l-7.5-14.3q-0.6-1-1.1-2-0.5-1-0.9-2.1-0.4-1.1-0.7-2.2-0.2-1.1-0.4-2.3 0-0.9 0.1-1.7 0-0.9 0.2-1.8 0.1-0.9 0.3-1.7 0.3-0.9 0.6-1.7c1.7-5.4 4.1-10.8 8.3-14.6 11.2-10.2 24.2 0.6 25.7 13.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m251.2 312l6.6-5.2q0.6-0.4 1.3-0.8 0.6-0.3 1.3-0.5 0.7-0.2 1.4-0.3 0.8-0.1 1.5-0.1c4.6 0.3 13.8 0.3 21.6 3.2 7 2.8 5.5 8.7 5.5 8.7 0 0-13.5-5.4-39.2-5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m283.5 439.3l5.8 17.3-3.7 0.8-2.6-8.3-1.2 8.9q-2.7 0.4-5.3 0.6-2.6 0.3-5.3 0.5-2.7 0.2-5.3 0.3-2.7 0-5.3 0.1c-18.4 0-59.7-4.1-59.7-4.1 0 0 0-15.1 4.5-20z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m225.7 684.2c0.1 0-4.4 8-4.4 8l-25.6-10.1 2.2-7.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m316.2 685.4c0.1 0-1.6 8.7-1.6 8.7h-27.3l-0.7-8z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m670.6 196.4l-9.2-0.1c-5-0.1-9.1-4.2-9-9.2 0-5.1 4.2-9.1 9.2-9.1l9.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m673.4 178.1l9.1 0.1c5.1 0 9.1 4.2 9.1 9.2-0.1 5.1-4.2 9.1-9.2 9.1l-9.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m670.4 217.3l-9.1-0.1c-5.1 0-9.2-4.2-9.1-9.2 0-5.1 4.2-9.1 9.2-9.1l9.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m670.3 229c-0.1 5.1-4.2 9.2-9.2 9.1-5.1 0-9.1-4.2-9.1-9.2 0-5.1 4.2-9.1 9.2-9.1l9.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m682.2 217.4c-5.1-0.1-9.1-4.2-9.1-9.2 0-5.1 4.2-9.1 9.2-9.1 5.1 0 9.1 4.2 9.1 9.2-0.1 5.1-4.2 9.1-9.2 9.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ps"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m138.7 135.7c-0.8-9.5-1.2-14.3 0.4-18.1 1.3-3.3 3.7-6.1 6.8-8 3.5-2.1 8.2-2.5 17.7-3.3l20.7-1.6c9.5-0.8 14.3-1.2 18.1 0.4 3.3 1.3 6.1 3.7 8 6.8 2.1 3.5 2.5 8.2 3.3 17.7l1.6 20.7c0.8 9.5 1.2 14.3-0.4 18.1-1.3 3.3-3.7 6.1-6.8 8-3.5 2.1-8.2 2.5-17.7 3.3l-20.7 1.6c-9.5 0.8-14.3 1.2-18.1-0.4-3.3-1.3-6.1-3.7-8-6.8-2.1-3.5-2.5-8.2-3.3-17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s32",
    d: "m157 162.2l-2.7-33q0-0.3 0.3-0.4c3.2-0.2 6.4-0.7 9.7-0.9 5.2-0.5 11 0.9 13.5 6.2q0.8 1.9 1 4.1 0.4 4.1-1.3 7c-3.1 5.3-9.1 5.7-14.6 6.1l0.9 10.3c0 0.3-0.2 0.5-0.5 0.5l-5.9 0.5q-0.4 0-0.4-0.4zm4.6-27.7l0.9 10.8c2.1-0.1 4.4-0.2 6.4-1.1 2.2-0.8 3.3-2.9 3.1-5.3-0.1-2-1.3-3.8-3.3-4.4-2.1-0.7-4.9-0.5-7.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m198.6 140.2q-1.5-0.6-3.1-0.8c-1.3-0.3-6.7-0.9-6.5 1.8 0.2 1.6 2.7 2.1 3.8 2.5 3.9 1 8.4 3 8.7 7.6 0.6 5.9-4.9 8.6-9.7 9-2.5 0.3-5.2 0.1-7.6-0.8-0.2-0.1-0.4-0.4-0.4-0.6l-0.4-5.6c-0.1-0.2 0.1-0.4 0.3-0.3 2.4 1.2 5.1 1.7 7.8 1.5 1.1-0.1 3.4-0.4 3.2-2.1-0.1-1.6-2.9-2.2-4-2.5q-2.5-0.6-4.7-1.9c-2-1.3-3.4-3.4-3.5-5.8-0.5-5.5 4.5-8.3 9.2-8.7 2.2-0.2 4.5-0.2 6.6 0.5 0.3 0 0.4 0.4 0.4 0.6l0.5 5.2c0 0.4-0.3 0.5-0.6 0.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.bd9f996398af730fcd9880b80a7813a6.svg";
export { ForwardRef as ReactComponent };